import React, { createContext, useCallback, useContext, useRef, useState, } from 'react';
import styled from 'styled-components';
import { SnackbarItem } from './SnackbarItem';
export const SnackbarContext = createContext({
    addSnackbar: () => {
        throw new Error('Please add the SnackbarContainer to your application');
    },
});
export const useSnackbarContext = () => useContext(SnackbarContext);
export const SnackbarContainer = ({ children, }) => {
    const snackbarIdRef = useRef(0);
    const [snackbars, setSnackbars] = useState([]);
    // create snackbar unique ID
    const newSnackId = useCallback(() => {
        const newId = `MM_SNACKBAR_${snackbarIdRef.current}`;
        snackbarIdRef.current = +1;
        return newId;
    }, []);
    const addSnackbar = useCallback((snackbar) => {
        const newSnack = {
            ...snackbar,
            id: newSnackId(),
        };
        setSnackbars([...snackbars, newSnack]);
    }, []);
    const deleteSnackbar = (id) => {
        setSnackbars(snackbars.filter((snackbar) => snackbar.id !== id));
    };
    return (React.createElement(SnackbarContext.Provider, { value: {
            addSnackbar,
        } },
        children,
        React.createElement(SnackbarWrapper, null, snackbars.map((snackbar) => (React.createElement(SnackbarItem, { key: snackbar.id, ...snackbar, deleteSnack: deleteSnackbar }))))));
};
const SnackbarWrapper = styled.div `
  position: fixed;
  bottom: 35px;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 90%;
  max-width: 875px;
  z-index: 1000;
`;
//# sourceMappingURL=SnackbarContainer.js.map